import React, {useState, useEffect} from 'react';
import { todaysVenues } from '../mySettings';

const generateFutureTimeIncrements = (startTime, endTime) => {
  // Get current time
  const now = new Date();
  const currentHours = now.getHours();
  const currentMinutes = now.getMinutes();
  const currentTotalMinutes = currentHours * 60 + currentMinutes;
  
  // Parse the start and end times
  const [startHours, startMinutes] = startTime.split(':').map(Number);
  const [endHours, endMinutes] = endTime.split(':').map(Number);
  
  // Convert to minutes since midnight for easier calculation
  let startTotalMinutes = startHours * 60 + startMinutes;
  let endTotalMinutes = endHours * 60 + endMinutes;
  
  // Handle case where end time is on the next day
  if (endTotalMinutes < startTotalMinutes) {
    endTotalMinutes += 24 * 60; // Add 24 hours worth of minutes
  }
  
  const result = [];
  
  // Round start time down to nearest 15 min increment
  const roundedStartMinutes = Math.floor(startTotalMinutes / 15) * 15;
  
  // Generate all 15-minute increments between start and end
  for (let minutes = roundedStartMinutes; minutes <= endTotalMinutes; minutes += 15) {
    // Skip times in the past
    if (minutes < currentTotalMinutes) {
      continue;
    }
    
    // Convert to hours and minutes
    const h = Math.floor(minutes / 60) % 24;
    const m = minutes % 60;
    
    // Format as hh:mm
    const formattedTime = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
    
    result.push(formattedTime);
  }
  
  return result;
};

function CartPage({ cartItems }) {
  const [startTime, setStart] = useState(todaysVenues[0].start);
  const [endTime, setEnd] = useState(todaysVenues[0].end);
  const [timeSlots, setTimeSlots] = useState([]);
  const [currentTime, setCurrentTime] = useState("");
  
  useEffect(() => {
    // Update time slots and current time
    const updateTimes = () => {
      const now = new Date();
      setCurrentTime(`${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`);
      setTimeSlots(generateFutureTimeIncrements(startTime, endTime));
    };
    
    // Initial update
    updateTimes();
    
    // Set up interval to update every minute
    const intervalId = setInterval(updateTimes, 60000);
    
    // Clean up interval on unmount
    return () => clearInterval(intervalId);
  }, [startTime, endTime]);

  

  //todo - load JSON times and locations



  const totalPrice = cartItems.reduce((total, item) => total + item.price, 0);

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Your Cart</h2>
      {cartItems.length === 0 ? (
        <p>Your cart is empty</p>
      ) : (
        <>
          {cartItems.map((item, index) => (
            <div key={index} className="flex justify-between items-center border-b py-2">
              <span>{item.name}</span>
              <span>£{item.price.toFixed(2)}</span>
            </div>
          ))}
          <div className="mt-4 font-bold">
            Total: £{totalPrice.toFixed(2)}
          </div>
          <div className="mt-4 font-bold">


            {timeSlots.length > 0 ? (
              <>
                <div>
                  <h2 className='text-3xl  mb-1 mt-8'>Pick up your pizza from <span className="font-bold">{todaysVenues[0].venue.label}</span> on <span className="font-bold">{todaysVenues[0].day} {todaysVenues[0].date}</span></h2>
                  <img
                    src={todaysVenues[0].venue.img.src}
                    alt={todaysVenues[0].venue.img.alt}
                    className="mx-auto rounded-lg mb-2 mt-4"
                  />
                </div>
                <h2 className='text-3xl  mb-1 mt-8'>Pick Up Time</h2>
                <select className="space-y-1 font-bolt text-3x1 m-4">
                  {timeSlots.map((time, index) => (
                    <option key={index} value={time} className="px-3 py-2 bg-gray-100 rounded">
                      {time}
                    </option>
                  ))}
                </select>
                <button 
                  className={`mt-4 w-full ${timeSlots.length > 0 ? 'bg-green-500' : 'bg-gray-400'} text-white py-2 rounded`} 
                  disabled={timeSlots.length === 0} 
                >
                  Checkout
                </button>
              </>
            ) : (
              <h3 className="text-2xl  mb-1 mt-8 text-red-800">Sorry, no more pizzas are available for pre-order today</h3>
            )}
          </div>

        </>
      )}
    </div>
  );
}

export default CartPage;
